



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Member } from '../../models/member.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { Subject } from 'rxjs';
import { MemberAccess } from '../../models/member-access.model';
import { MemberAccessActionType } from '../../models/enums';

@Component({
    selector: 'error-detail',
    template: require('./error-detail.component.html'),
    styles: [require('./error-detail.component.css')],
    animations: [fadeInOut]
})
export class ErrorDetailComponent {
    searchText: string;
    isGettingMembers = false;
    memberDetailsParams: any = {};
    history: Member[] = [];
    currentUser: User;
    isSearching = false;
    errorDetailPagedResult : any= {
        results: [],
        rowCount: 0,
        currentPage: 1,
        pageSize: 20
    };
    totalHistory: any;
    fileName ="";
    isExporting = false;

    //page = {
    //    pageNumber: 1,
    //    size: 10,
    //}

    private subject: Subject<string> = new Subject();

    constructor(private router: Router, private apiService: ApiService, private authService: AuthService,
        private activateRouter: ActivatedRoute,
        public dialog: MatDialog, private alertService: AlertService) {

        this.fileName = this.activateRouter.snapshot.queryParams.name;
        this.getPagedResult(this.fileName, this.errorDetailPagedResult.currentPage, this.errorDetailPagedResult.pageSize);
        

    }

    //getTotalHistory() {
    //    this.apiService.getAllMemberAccessLastRecords().subscribe(r => {
    //        this.totalHistory = r.length;
    //        console.log(this.totalHistory)
    //    })
    //}

    onRefresh() {
        this.errorDetailPagedResult.results = [];
        this.errorDetailPagedResult.currentPage = 0;
        this.getPagedResult(this.fileName, this.errorDetailPagedResult.currentPage + 1, this.errorDetailPagedResult.pageSize);
    }

    onExport() {
        this.isExporting = true;
        this.apiService.exportInboundFileErrors(this.fileName).subscribe((blob: Blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = this.fileName.replace(/\.[^.]*$/, '') + '_errors.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            this.isExporting = false;
        }, () => {
            this.isExporting = false;
            this.alertService.showMessage("Export failed", "Could not export the errors for " + this.fileName, MessageSeverity.error);
        });
    }

    getChangePage(page) {
       // this.page.pageNumber = page.offset
        //console.log(this.page)
        this.errorDetailPagedResult.results = [];
        this.getPagedResult(this.fileName, page.offset + 1, this.errorDetailPagedResult.pageSize);
    }


    getPagedResult(fileName, page, pageSize) {
        this.apiService.getInboundFileErrorDetail(fileName, page, pageSize).subscribe(r => {
            this.errorDetailPagedResult = r;
            //this.errorDetailPagedResult.currentPage--;
            console.log(this.errorDetailPagedResult)
        })
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/error-detail/error-detail.component.ts